
import { Suspense, useRef, useEffect, useState } from "react";
import ApiServices from "../../service/ApiServices";
import { motion } from "framer-motion";

import { Spinner } from "../template/spinner/spinner";
import { ProductCard } from "../template/product-card/product-card";
import { BackButton } from "../template/buttons/back-btn/back-btn";


export const Search = () => {

    const [query, setQuery] = useState('');
    const [searchResult, setSearchResult] = useState([]);
    const [warning, setWarning] = useState(null);
    const input  = useRef();

    const res = new ApiServices();

    const handleSearch = (e) => {
        e.preventDefault();

        const target = e.target;

        const query = target.value;
        setQuery(query);
    }

    useEffect(() => {
        input.current.focus();
    }, []);

    useEffect(() => {
        const regex = /^[A-Za-zА-Яа-я0-9- ]+$/;
        if (!regex.test(query) && query.length !== 0) {
            setWarning({message: "Введено неприпустимі символи. Будь ласка, використовуйте лише літери та цифри."})
        } else {
            res.getSearchResult(query)
            .then(data => {
                if (warning !== null) {
                    setWarning(null)
                }
                setSearchResult(data);
            })
        }
    }, [query]);

    const items = searchResult.map(product => (
        <ProductCard key={product.id} props={product}/>
    ))

    return (
        <motion.div className="container-fluid"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5 } }}
            exit={{ opacity: 0 }}
        >
             <BackButton/>
             <div className="row">
                <form className="my-2 mb-2 my-lg-0" >
                    <div className="input-group position-relative">
                        <input className="form-control mr-sm-2 pe-4 border-dark" ref={input} onChange={handleSearch} name="s" type="text" placeholder="Пошук"  />
                        
                    </div>
                    {warning?.message && 
                        <label htmlFor="s"  className="form-label my-2">
                            <div className="p-2 fs-6 border border-danger text-danger rounded-4"> {warning.message}</div>
                        </label>
                    }
                </form>
             </div>
             <div className="row">
                <Suspense fallback={<Spinner/>}>
                    {items}
                </Suspense>
             </div>
        </motion.div>
    )
}
